var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrapper container-xxl p-0" },
    [
      _c("div", { staticClass: "content-header row" }),
      _c("div", { staticClass: "content-body" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _vm.loading
              ? _c("b-spinner", {
                  staticStyle: { width: "3rem", height: "3rem" },
                  attrs: { variant: "success", label: "Spinning" },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.sortedItemUOM, function (item) {
              return _c(
                "div",
                { key: item, staticClass: "col-xl-4 col-lg-6 col-md-6" },
                [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-end mt-1 pt-25",
                        },
                        [
                          _c("div", { staticClass: "uom-heading" }, [
                            _c("h4", { staticClass: "fw-bolder" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-edit-uom",
                                    modifiers: { "modal-edit-uom": true },
                                  },
                                ],
                                staticClass: "uom-edit-modal",
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function ($event) {
                                    return _vm.sendInfo(item)
                                  },
                                },
                              },
                              [
                                _c("small", { staticClass: "fw-bolder" }, [
                                  _vm._v("Edit UOM"),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._m(0, true),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            _c("div", { staticClass: "col-xl-4 col-lg-6 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-body text-sm-end text-center ps-sm-0",
                      },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-add",
                                modifiers: { "modal-add": true },
                              },
                            ],
                            staticClass:
                              "stretched-link text-nowrap add-new-uom",
                            attrs: { href: "javascript:void(0)" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "btn btn-primary mb-3" },
                              [_vm._v("Add New Unit of measure")]
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v("Add unit of measure, if it does not exist"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ],
          2
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-add",
            "ok-only": "",
            "ok-title": "Accept",
            centered: "",
            size: "lg",
            title: "Add new uom",
            "hide-footer": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-body px-5 pb-5" },
            [
              _c("div", { staticClass: "text-center mb-4" }, [
                _c("h1", { staticClass: "uom-title" }, [
                  _vm._v("Add New Unit of meaure"),
                ]),
              ]),
              _c(
                "validation-observer",
                { ref: "uom" },
                [
                  _c(
                    "b-form",
                    {
                      staticClass: "row",
                      attrs: { id: "addUomForm" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.validationForm($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "modalUOMName" },
                            },
                            [_vm._v("Unit of measure")]
                          ),
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "UOM Name",
                              vid: "UOM Name",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "modalUOMName",
                                        state: errors.length > 0 ? false : null,
                                        name: "modalUOMName",
                                        placeholder:
                                          "Enter Unit of measure name",
                                      },
                                      model: {
                                        value: _vm.AddName,
                                        callback: function ($$v) {
                                          _vm.AddName = $$v
                                        },
                                        expression: "AddName",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("div"),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-center mt-2 d-flex justify-content-between",
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-primary me-1",
                              attrs: { type: "submit" },
                              on: { click: _vm.addUOM },
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v("Add Unit of measure"),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-edit-uom",
            "ok-only": "",
            "ok-title": "Accept",
            centered: "",
            size: "lg",
            title: "Edit uom",
            "hide-footer": "true",
          },
          on: { hidden: _vm.reloadpage },
        },
        [
          _c(
            "div",
            { staticClass: "modal-body px-5 pb-5" },
            [
              _c("div", { staticClass: "text-center mb-4" }, [
                _c("h1", { staticClass: "uom-title" }, [
                  _vm._v("Edit this uom"),
                ]),
              ]),
              _c(
                "validation-observer",
                { ref: "uom" },
                [
                  _c(
                    "b-form",
                    {
                      staticClass: "row",
                      attrs: { id: "editUOMForm" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.validationForm($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12 my-1" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "modalUOMName" },
                            },
                            [_vm._v("UOM Name")]
                          ),
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "UOM Name",
                              vid: "UOM Name",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        state: errors.length > 0 ? false : null,
                                        type: "text",
                                        id: "modalUOMName",
                                        name: "modalUOMName",
                                        placeholder:
                                          "Enter Unit of measure name",
                                      },
                                      model: {
                                        value: _vm.selectedUOM.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.selectedUOM, "name", $$v)
                                        },
                                        expression: "selectedUOM.name",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12 d-flex justify-content-end" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeUOM(_vm.selectedUOM.id)
                                },
                              },
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v("Delete "),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-primary me-1",
                              attrs: { type: "submit" },
                              on: {
                                click: function ($event) {
                                  return _vm.updateUOM()
                                },
                              },
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v("Edit"),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "text-body", attrs: { href: "javascript:void(0);" } },
      [
        _c("i", {
          staticClass: "font-medium-5",
          attrs: { "data-feather": "copy" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }